import { DealRegistryPageListDueDiligenceRecordsQuery, Security_Status } from '@/__generated__/graphql';
import DropdownActions from '@/components/table/dropdownActions';
import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';
import { TableColumns } from '@/components/table/types';
import { useAuth } from '@/hooks/use-auth';
import { useTranslation } from 'react-i18next';
import { NavigateOptions } from 'react-router-dom';
import styled from 'styled-components';
import { actionDropdownItems } from '../utils';
import { cellValue } from './table';

interface DealRegistryMobileTableProps {
  columnsList: TableColumns[];
  dealRegistryRows: DealRegistryPageListDueDiligenceRecordsQuery['listDueDiligenceRecords']['records'];
  openPage: (path: string, options?: NavigateOptions) => void;
  openModalWindow: (row: DealRegistryPageListDueDiligenceRecordsQuery['listDueDiligenceRecords']['records'][number], type: string) => void;
  handleUpdateInvestmentStatus: (
    row: DealRegistryPageListDueDiligenceRecordsQuery['listDueDiligenceRecords']['records'][number],
    status: Security_Status
  ) => void;
}

const DealRegistryMobileTable = ({
  columnsList,
  dealRegistryRows,
  openPage,
  openModalWindow,
  handleUpdateInvestmentStatus
}: DealRegistryMobileTableProps) => {
  const { user } = useAuth();
  const { t } = useTranslation('enums');

  const TableRow = ({ el }: { el: DealRegistryPageListDueDiligenceRecordsQuery['listDueDiligenceRecords']['records'][number] }) => {
    return (
      <CustomMobileTableRowWrap key={el.id}>
        <MobileRow>
          <MobileRowTitle>{columnsList[0].title}</MobileRowTitle>
          <FixedMobileRowValue isRedirect>
            <div onClick={() => openPage(`/dueDiligence/${el.id}?backToTitle=Deal Registry`)}>{el.investment.name}</div>
            <DropdownActionsWrapper>
              <DropdownActions isMobile items={actionDropdownItems(el, user, openPage, openModalWindow, handleUpdateInvestmentStatus)} />
            </DropdownActionsWrapper>
          </FixedMobileRowValue>
        </MobileRow>
        {columnsList
          .filter((column) => !column.isFixed)
          .map(
            (column, index) =>
              !column.isHidden && (
                <MobileRow key={column.keySort + index}>
                  <MobileRowTitle>{column.title}</MobileRowTitle>
                  <MobileRowValue key={column.key}>{cellValue(el, column, t)}</MobileRowValue>
                </MobileRow>
              )
          )}
      </CustomMobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {dealRegistryRows.length ? (
        dealRegistryRows.map((el: DealRegistryPageListDueDiligenceRecordsQuery['listDueDiligenceRecords']['records'][number]) => {
          return <TableRow key={el.id} el={el} />;
        })
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default DealRegistryMobileTable;

const CustomMobileTableRowWrap = styled(MobileTableRowWrap)`
  margin-top: 5px;
`;

const FixedMobileRowValue = styled(MobileRowValue)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
`;

const DropdownActionsWrapper = styled.div`
  width: max-content;
`;
